import type { UserConfigurationState, ShortTurnConfig } from '@/types';
import { toast } from "@/components/ui/sonner";
import { initialOnboardingState } from '@/constants/initialState';

export const updateCurrentShortTurnConfig = (
  currentConfig: UserConfigurationState['shortTurnConfig'],
  updateBillingConfig: (config: Partial<UserConfigurationState>) => void,
  updates: Partial<NonNullable<UserConfigurationState['shortTurnConfig']>>
) => {
  const finalUpdates = { ...updates };
  if (finalUpdates.surchargeType === 'hourly_premium' && !(currentConfig?.premiumType)) {
    finalUpdates.premiumType = 'fixed';
  }
  updateBillingConfig({
    shortTurnConfig: { ...(currentConfig || initialOnboardingState.shortTurnConfig!), ...finalUpdates } as ShortTurnConfig,
  });
};

export const handleUsesShortTurnToggle = (
  shortTurnConfig: UserConfigurationState['shortTurnConfig'],
  rateMultipliers: UserConfigurationState['rateMultipliers'],
  updateBillingConfig: (config: Partial<UserConfigurationState>) => void,
  checked: boolean
) => {
  // If the user has no extra multipliers, default to Fixed-Dollar;
  // otherwise fall back to Straight Time.
  const baseConfig = shortTurnConfig || initialOnboardingState.shortTurnConfig!;
  const hasExtra = (rateMultipliers ?? []).some(m => m.code !== "STRAIGHT_TIME");
  const defaultMode = hasExtra ? "carry_over" : "fixed_dollar";

  updateBillingConfig({
    usesShortTurn: checked,
    shortTurnConfig: {
      ...baseConfig,
      surchargeType: checked ? defaultMode : null,   // clear mode when disabling
    } as ShortTurnConfig,
  });

  toast.success(checked ? "Short-turn surcharge enabled" : "Short-turn surcharge disabled");
};

